<div class="onlineSwitch">
  <div style="display: table-cell; vertical-align: middle;">
    @if (onlineSwitch.value==true) {
      <span>
        <img src="{{'assets/img/online.png' || ''}}" />
      ONLINE </span>
    }
    @if (onlineSwitch.value==false) {
      <span>
        <img src="{{'assets/img/offline.png' || ''}}" />
        OFFLINE
      </span>
    }
    <label class="switch">
      <input [formControl]="onlineSwitch" type="checkbox" (change)="switchChange()">
      <span class="slider vPlaybookActiveToggle round"></span>
    </label>
  </div>
</div>

<ng-template #infoModal>
  <div class="modal-content">
    <div class="modal-header">
      <i class="material-icons" data-bs-dismiss="modal" (click)='closeModal()'>close</i>
    </div>
    <div class="modal-body">
      <div class="row text-center">
        <label class="col-12">{{msg}}</label>
      </div>
    </div>
  </div>
</ng-template>
